import { motion } from "framer-motion";
import { Gift, Heart, Package } from "lucide-react";

const AmazonWishlist = () => {
  return (
    <div data-testid="amazon-wishlist-page">
      {/* Hero Section */}
      <section className="pt-32 pb-16 relative overflow-hidden">
        <div className="absolute inset-0">
          <div className="absolute inset-0 bg-gradient-to-b from-[#4A5320]/20 to-transparent" />
        </div>
        <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
          >
            <span className="font-mono text-[#FFD700] text-sm uppercase tracking-widest mb-4 block">
              Shop For Our Fosters
            </span>
            <h1 className="font-['Bebas_Neue'] text-6xl md:text-7xl text-white mb-6">
              Amazon Wishlist
            </h1>
            <p className="text-[#A3A3A3] text-lg md:text-xl max-w-2xl mx-auto leading-relaxed">
              Can&apos;t donate cash? You can still help by purchasing items our foster pets need! 
              Browse our wishlist and have items shipped directly to us.
            </p>
          </motion.div>
        </div>
      </section>

      {/* How It Works */}
      <section className="py-12 bg-[#0A0A0A]">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="text-center"
            >
              <div className="w-16 h-16 bg-[#4A5320]/30 rounded-full flex items-center justify-center mx-auto mb-4">
                <Gift className="w-8 h-8 text-[#FFD700]" />
              </div>
              <h3 className="font-['Bebas_Neue'] text-xl text-white mb-2">Browse Items</h3>
              <p className="text-[#A3A3A3] text-sm">
                Browse our wishlist for items our foster pets need most
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.1 }}
              className="text-center"
            >
              <div className="w-16 h-16 bg-[#4A5320]/30 rounded-full flex items-center justify-center mx-auto mb-4">
                <Package className="w-8 h-8 text-[#FFD700]" />
              </div>
              <h3 className="font-['Bebas_Neue'] text-xl text-white mb-2">Purchase & Ship</h3>
              <p className="text-[#A3A3A3] text-sm">
                Buy items through Amazon and have them shipped directly to us
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2 }}
              className="text-center"
            >
              <div className="w-16 h-16 bg-[#4A5320]/30 rounded-full flex items-center justify-center mx-auto mb-4">
                <Heart className="w-8 h-8 text-[#FFD700]" />
              </div>
              <h3 className="font-['Bebas_Neue'] text-xl text-white mb-2">Help Animals</h3>
              <p className="text-[#A3A3A3] text-sm">
                Your purchases directly support our rescue animals in need
              </p>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Wishlist Iframe */}
      <section className="py-16 bg-[#0A0A0A]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="bg-[#1A1C18] border border-[#4A5320] rounded-lg overflow-hidden"
          >
            <iframe
              src="https://rescuesupportkit.com/rescue/rescue_default_teb/wishlists"
              title="Three Eye Blind Animal Rescue - Amazon Wishlist"
              className="w-full border-0"
              style={{ minHeight: '600px', height: '80vh', maxHeight: '900px' }}
              loading="lazy"
            />
          </motion.div>
        </div>
      </section>

      {/* Additional Info */}
      <section className="py-16 bg-[#0D0D0B]">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <h2 className="font-['Bebas_Neue'] text-3xl text-white mb-4">
              Every Item Makes a Difference
            </h2>
            <p className="text-[#A3A3A3]">
              From food and treats to medical supplies and comfort items, every purchase from our wishlist 
              goes directly to supporting our foster animals. Thank you for helping us save lives!
            </p>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default AmazonWishlist;
